module.exports = __webpack_public_path__ + "static/img/Lance_Franklin_desktop.25da22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lance_Franklin_desktop.jpg
// module id = n7Nf
// module chunks = 0